import {
  Component,
  OnInit
} from '@angular/core';

@Component({
	standalone: false,
  selector: 'app-items',
  templateUrl: './items.component.html',
  styleUrls: ['./items.component.scss']
})
export class ItemsComponent implements OnInit {
    constructor() {
    }
  ngOnInit(): void {
  }

}
